import React, { useState } from 'react';
import { MapPin, Maximize2, X } from 'lucide-react';

// ✅ YOUR PHOTOS
const DRONE_PHOTOS = [
    {
        id: 1,
        src: '/images/Drone/Skatepark1.jpg',
        caption: 'Westpark Skate Park',
        location: 'Canton, OH'
    },
    {
        id: 2,
        src: '/images/Drone/Skatepark2.jpg',
        caption: 'Westpark Skate Park',
        location: 'Canton, OH'
    },
    {
        id: 3,
        src: '/images/Drone/watertower.jpg',
        caption: 'Dorchester County Water Authority Water Tower',
        location: 'Summerville, SC'
    },
    {
        id: 4,
        src: '/images/Drone/batterypark.jpg',
        caption: 'Battery Park downtown',
        location: 'Charleston, SC'
    },
    {
        id: 5,
        src: '/images/Drone/shayridge.jpg',
        caption: 'Shay Ridge Rd',
        location: 'Archers Fork, OH'
    },
    {
        id: 6,
        src: '/images/Drone/circlek.jpg',
        caption: 'Circle K at dusk',
        location: 'Barberton, OH'
    },

    // Copy the block above to add more photos
];

const DroneGallery = () => {
    // State to track which image is currently open (if any)
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div className="w-full max-w-7xl mx-auto px-6 py-12">
            {/* Header */}
            <div className="mb-8 pb-4 text-center">
                <h2 className="text-gray-800 text-4xl font-bold inline pb-12">Drone Photography</h2>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {DRONE_PHOTOS.map((photo) => (
                    <div
                        key={photo.id}
                        // ✅ This makes the click work
                        onClick={() => setSelectedImage(photo)}
                        className="group relative block overflow-hidden rounded-xl shadow-lg bg-slate-100 cursor-pointer"
                    >
                        {/* Image Container (16:9 Aspect Ratio) */}
                        <div className="aspect-video w-full overflow-hidden">
                            <img
                                src={photo.src}
                                alt={photo.caption}
                                className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-700 ease-in-out"
                                loading="lazy"
                            />
                        </div>

                        {/* Hover Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                            <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                                <div className="absolute top-4 right-4 text-white/80">
                                    <Maximize2 className="w-5 h-5" />
                                </div>

                                <p className="text-white font-medium text-lg truncate">
                                    {photo.caption}
                                </p>

                                <div className="flex items-center mt-2 text-white/70 text-sm">
                                    <MapPin className="w-4 h-4 mr-1" />
                                    <span>{photo.location}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* ✅ LIGHTBOX MODAL (The Fullscreen View) */}
            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm"
                    onClick={() => setSelectedImage(null)} // Click background to close
                >
                    {/* Close Button */}
                    <button
                        className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors"
                        onClick={() => setSelectedImage(null)}
                    >
                        <X className="w-10 h-10" />
                    </button>

                    {/* Full Size Image */}
                    <div className="max-w-6xl max-h-screen relative" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={selectedImage.src}
                            alt={selectedImage.caption}
                            className="max-h-[85vh] w-auto rounded-md shadow-2xl"
                        />
                        <div className="mt-4 text-center">
                            <h3 className="text-white text-xl font-light tracking-wide">{selectedImage.caption}</h3>
                            <p className="text-white/60 text-sm mt-1">{selectedImage.location}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DroneGallery;